export const adaptTipoInsumo = (tipoInsumo) => {
    return {
        id: tipoInsumo?.idTipoInsumo,
        displayName: tipoInsumo?.descripcion
    }
}

export const adaptTipoInsumoArray = (
    tipoInsumos
) => {
    return structuredClone(tipoInsumos?.tiposInsumos?.valorEsperado)
        ?.map(tipoInsumo => adaptTipoInsumo(tipoInsumo));
}